import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Table } from 'antd';

import styled from 'styled-components';
import BreadCrumb from '../../../components/BreadCrumb';
import Wait4Me from '../../../components/Wait4Me';
import { columnParser } from './utils';
import RejectConfirmationModal from '../../../components/ns/TicketsTable/RejectConfirmationModal';
import style from './index.scss';
import { MODULE_SOURCEID_MAPPING } from '../../../util/GlobalConstant';
import { get } from '../../../util/lodashlike';

const LoadingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Tickets = (props) => {
  const {
    apiActions,
    settings,
    ticketsList,
    approveAndReject,
    authentication
  } = props;
  const { getNSGlobalSettingsPageInfo, getAMLSCommonTickets } = apiActions;
  const { isLoading, data } = ticketsList;

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [rowSelected, setRowSelected] = useState(null);
  const [isRejectConfirmationModalOpen, setIsRejectConfirmationModalOpen] =
    useState(false);

  useEffect(() => {
    getNSGlobalSettingsPageInfo({ pageId: 'NS_IAD_TICKETS' });
  }, []);

  const sourceId =
    MODULE_SOURCEID_MAPPING[
      get(authentication, 'currentProductLogin.moduleCode')
    ] || '';

  useEffect(() => {
    getAMLSCommonTickets({
      offset: (currentPage - 1) * pageSize,
      limit: pageSize,
      sourceId
    });
  }, [pageSize, currentPage]);

  const pageRefreshHandler = () => {
    getAMLSCommonTickets({
      offset: (currentPage - 1) * pageSize,
      limit: pageSize,
      sourceId
    });
  };

  const onRejectIconClickedHanlder = (d) => {
    setRowSelected(d);
    setIsRejectConfirmationModalOpen(true);
  };

  const onPaginationChange = (page, newPageSize) => {
    setCurrentPage(page);
    setPageSize(newPageSize);
  };

  // To Get Global Settings Configuration
  const getGSConfig = (q) => {
    if (settings?.nsSetting?.data?.uiWidgetGroups) {
      const groups = settings.nsSetting.data.uiWidgetGroups;
      return groups
        .find((g) => g.widgetGroupId === q.widgetGroupId)
        ?.widgets.find((w) => w.widgetId === q.widgetId);
    }
    return {};
  };

  // Global Settings config
  const GS = getGSConfig({
    widgetGroupId: 'NS_IAD_TICKET_LIST',
    widgetId: 'NS_IAD_TICKET_LIST'
  });

  //Table Column data
  const columns = columnParser(
    GS && GS.widgetConfig,
    apiActions,
    onRejectIconClickedHanlder
  );

  return (
    <Fragment>
      <Row>
        <Col span={24}>
          <div className={style.ticket_wrapper}>
            <div className={style.head}>
              <BreadCrumb crumbs={[{ label: 'Tickets' }]} />
              <div className={style.head_content}>
                <h4>Tickets</h4>
              </div>
            </div>
            <div className={style.body}>
              <div className={style.heading}>Tickets</div>
              {settings?.nsSetting?.isLoading ? (
                <LoadingWrapper>
                  <Wait4Me />
                </LoadingWrapper>
              ) : (
                <Table
                  id="ticketLsitingTable"
                  className={style.table}
                  dataSource={data?.payload}
                  columns={columns}
                  loading={isLoading}
                  rowKey="id"
                  pagination={{
                    showSizeChanger: true,
                    responsive: false,
                    total: data?.total,
                    current: currentPage,
                    pageSize,
                    onChange: onPaginationChange,
                    pageSizeOptions: [5, 10, 25, 50, 100],
                    showTotal: (total) => `${total} Records`
                  }}
                  scroll={{ y: 270 }}
                />
              )}
            </div>
            {isRejectConfirmationModalOpen && (
              <RejectConfirmationModal
                data={rowSelected}
                open={isRejectConfirmationModalOpen}
                isModalOpen={setIsRejectConfirmationModalOpen}
                onRejectConfirmed={
                  apiActions?.putAMLSCommonApproveAndRejectTicket
                }
                approveAndRejectData={approveAndReject}
                refreshPage={pageRefreshHandler}
              />
            )}
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

Tickets.propTypes = {
  apiActions: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  ticketsList: PropTypes.object.isRequired,
  approveAndReject: PropTypes.object.isRequired,
  authentication: PropTypes.object
};

export default Tickets;
